// eslint-disable-next-line
import tw from 'twin.macro';

import { useTheme } from '@themes/useTheme';
import { SunIcon } from '@icons/SunIcon';
import { MoonIcon } from '@icons/MoonIcon';

const Wrapper = tw.div`rounded-[6px] fill-current bg-gray-2 p-[2px] flex justify-start gap-[2px] shadow-small-inset overflow-hidden`;
const IconWrapper = tw.div`rounded-[5px] p-[4px]`;

export function ThemeToggler() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <Wrapper onClick={toggleTheme} css={[isDark && tw`justify-end`]}>
      <IconWrapper css={[!isDark && tw`bg-neutral-background shadow-small`]}>
        <SunIcon tw='fill-text-and-icon-muted-2' />
      </IconWrapper>
      <IconWrapper css={[isDark && tw`bg-neutral-background shadow-small`]}>
        <MoonIcon tw='fill-text-and-icon-muted-2' />
      </IconWrapper>
    </Wrapper>
  );
}
